import Firebase from 'firebase'
import 'firebase/firestore'

const config = {
  apiKey: 'AIzaSyCvrL7j8uTaNyKqJPqPVhdqklmqUhn2S_w',
  authDomain: 'fluke-dev.firebaseapp.com',
  databaseURL: 'https://fluke-dev.firebaseio.com',
  projectId: 'fluke-dev',
  storageBucket: 'fluke-dev.appspot.com',
  messagingSenderId: '611024575669',
  appId: '1:611024575669:web:6c40a3c3e41bb4b94972fc',
  measurementId: 'G-ME52V6F1R6'
}

const firebaseApp = Firebase.initializeApp(config, 'exercise-vue')
const firestore = firebaseApp.firestore()
const storage = firebaseApp.storage()
firestore.settings({ timestampsInSnapshots: true })

export { firestore, storage }



// WEBPACK FOOTER //
// ./src/firebase/firestore.js